import { IWebsiteBuilderFormRowRaw } from "redux/reducers/models/websiteBuilder";
import { IFormBuilderEntityBase } from "./formBuilderEntity";
import { TFormBuilderItem } from "./item/formBuilderItem";
import { IFormBuilderDesignStyles } from "./formBuilderDesignStyles";
import { FORM_BUILDER_FORM_GAP } from "./formBuilderForm";
import { CSSProperties } from "react";

export type TFormBuilderRowJustifyContent = "flex-start" | "center" | "flex-end" | "space-between";
export type TFormBuilderRowAlignItems = "flex-start" | "center" | "flex-end";

export interface IFormBuilderRowSettings {
  justifyContent: TFormBuilderRowJustifyContent;
  alignItems: TFormBuilderRowAlignItems;
}

export interface IFormBuilderRowData {
  formId: number;
  settings: IFormBuilderRowSettings;
}

export interface IFormBuilderRow extends IFormBuilderEntityBase {
  type: "row";
  data: IFormBuilderRowData;
  children: TFormBuilderItem[];
}

export type TFormBuilderRowSettings = IFormBuilderRow["data"]["settings"];

export function isWebsiteBuilderFormRowRawValid(rawRow: IWebsiteBuilderFormRowRaw): boolean {
  return (
    rawRow?.id != null &&
    rawRow?.form_id != null &&
    rawRow?.key != null
  );
}

export function isFormBuilderRowJustifyContent(value: string): value is TFormBuilderRowJustifyContent {
  return value === "flex-start" || value === "center" || value === "flex-end" || value === "space-between";
}

export function isFormBuilderRowAlignItems(value: string): value is TFormBuilderRowAlignItems {
  return value === "flex-start" || value === "center" || value === "flex-end";
}

export function formBuilderGenerateDefaultRow(
  children: TFormBuilderItem[],
  key: string = crypto.randomUUID(),
): IFormBuilderRow {
  return {
    id: null,
    key,
    type: "row",
    data: {
      formId: null,
      settings: {
        justifyContent: "flex-start",
        alignItems: "flex-start",
      },
    },
    children,
  };
}

export function formBuilderGenerateRowDesignStyles(row: IFormBuilderRow): IFormBuilderDesignStyles {
  const styleProperties: CSSProperties = {
    gap: `${FORM_BUILDER_FORM_GAP}px`,
    justifyContent: row.data.settings.justifyContent,
    alignItems: row.data.settings.alignItems,
  };

  let styleDeclaration = "";
  
  styleDeclaration += `gap: ${styleProperties.gap};`;
  styleDeclaration += `justify-content: ${styleProperties.justifyContent};`;
  styleDeclaration += `align-items: ${styleProperties.alignItems};`;

  return {
    className: "form-builder-row",
    styleProperties,
    styleDeclaration,
  };
}